import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core'
import { TitleCasePipe } from '@angular/common'
import { provideRouter } from '@angular/router'
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http'
import { provideAnimations } from '@angular/platform-browser/animations'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule, MetaReducer } from '@ngrx/store'
import { APP_ROUTES } from './app.routes'
import { reducers, effects } from './state'
import { storeFreeze } from 'ngrx-store-freeze'
import { provideEnvironmentNgxMask } from 'ngx-mask'
import {
   AppConfigProvider,
   HttpRequestInterceptor,
   JQUERY_TOKEN,
   MOMENT_TOKEN,
   Toastr,
   TOASTR_TOKEN
} from './shared/services'
import { provideToastr } from 'ngx-toastr'
import { environment } from '@appEnvironments/environment'

/* eslint-disable @typescript-eslint/dot-notation */
const toastr: Toastr = window['toastr']
const moment = window['moment']
const jQuery = window['$']
/* eslint-enable @typescript-eslint/dot-notation */

/* extend the existing window interface to tell it about your new property. */
declare global {
   interface Window {
      swre_portal: any
   }

   interface Date {
      stdTimezoneOffset(): number

      isDstObserved(): boolean
   }
}

window.swre_portal = window.swre_portal || { api_history: [], errors: [] }

export const metaReducers: MetaReducer<any>[] = !environment.production
   ? [storeFreeze]
   : []

export const appConfig: ApplicationConfig = {
   providers: [
      provideAnimations(),
      provideHttpClient(withInterceptorsFromDi()),
      provideRouter(APP_ROUTES),
      importProvidersFrom(
         StoreModule.forRoot(reducers, {
            metaReducers
         }),
         EffectsModule.forRoot(effects),
      ),
      provideAppInitializer(() => {
         const appConfigProvider = inject(AppConfigProvider);
         return appConfigProvider.init();
      }),
      {
         provide: Window,
         useValue: window
      },
      {
         provide: HTTP_INTERCEPTORS,
         useClass: HttpRequestInterceptor,
         multi: true
      },
      TitleCasePipe,
      //TODO - maybe "provide" these where they are actually used
      { provide: TOASTR_TOKEN, useValue: toastr },
      { provide: MOMENT_TOKEN, useValue: moment },
      { provide: JQUERY_TOKEN, useValue: jQuery },
      provideEnvironmentNgxMask(),
      provideToastr()
   ]
}

Date.prototype.stdTimezoneOffset = function (): number {
   const jan = new Date(this.getFullYear(), 0, 1)
   const jul = new Date(this.getFullYear(), 6, 1)
   return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())
}

Date.prototype.isDstObserved = function (): boolean {
   return this.getTimezoneOffset() < this.stdTimezoneOffset()
}
